import { LoaderMode, LoaderStartConfig } from '../models/loading.models';

export interface LoaderModeDefaults {
  delayMs: number;
  minVisibleMs: number;
  blocking: boolean;
  priority: number;
}

const LOADER_MODE_DEFAULTS: Record<LoaderMode, LoaderModeDefaults> = {
  'fullscreen-blocking': {
    delayMs: 200,
    minVisibleMs: 400,
    blocking: true,
    priority: 400,
  },
  'section-blocking': {
    delayMs: 150,
    minVisibleMs: 300,
    blocking: true,
    priority: 300,
  },
  'top-bar': {
    delayMs: 100,
    minVisibleMs: 250,
    blocking: false,
    priority: 200,
  },
  'inline-nonblocking': {
    delayMs: 0,
    minVisibleMs: 150,
    blocking: false,
    priority: 100,
  },
};

export function getLoaderModeDefaults(loaderMode: LoaderMode): LoaderModeDefaults {
  return LOADER_MODE_DEFAULTS[loaderMode];
}

export function resolveLoaderStartConfig(
  loaderStartConfig: LoaderStartConfig
): LoaderStartConfig {
  const loaderModeDefaults = getLoaderModeDefaults(loaderStartConfig.mode);

  return {
    ...loaderStartConfig,
    blocking: loaderStartConfig.blocking ?? loaderModeDefaults.blocking,
    priority: loaderStartConfig.priority ?? loaderModeDefaults.priority,
    delayMs: loaderStartConfig.delayMs ?? loaderModeDefaults.delayMs,
    minVisibleMs:
      loaderStartConfig.minVisibleMs ?? loaderModeDefaults.minVisibleMs,
  };
}
